import React from 'react';

import {
  Dropdown,
  Slider,
  Switch,
  SvgIcon,
} from '../../ui-helpers';

import {
  FingerSize,
  // RingSizes,
  SliderContainer,
  IconWithTitle,
  SwitchContainer,
  Notification,
  InfoIcon,
  Info,
  SliderTitle,
  DimensionsSliders,
} from './Dimensions-styled';


interface Props {
  fingerSize:string,
  fingerSizeOptions:string[],
  onFingerSizeChange:(value:string)=>void,

  fingerSizeFormat:string,
  fingerSizeFormatOptions:string[],
  onFingerSizeFormatChange:(value:string)=>void,

  ringWidth:number,
  ringWidthOptions:number[],
  onRingWidthChange:(value:number)=>void,

  ringThickness:number,
  ringThicknessOptions:number[],
  onRingThicknessChange:(value:number)=>void,

  autoRatio:boolean,
  onAutoRatioChange:(value:boolean)=>void,

  checkoutIssues:('fingerSize'|'debug')[],

  scrolling:boolean
}

export default class extends React.Component<Props,{}> {
  constructor(props: Props) {
    super(props);
  };// /constructor()

  render = () => {
    const {
      fingerSize,
      onFingerSizeChange,
      fingerSizeFormat,
      fingerSizeFormatOptions,
      onFingerSizeFormatChange,
      ringWidth,
      ringWidthOptions,
      onRingWidthChange,
      ringThickness,
      ringThicknessOptions,
      onRingThicknessChange,
      autoRatio,
      onAutoRatioChange,
      checkoutIssues,
      scrolling
    } = this.props;

    const fingerSizeOptions = this.props.fingerSizeOptions.map((fso) => {
      fso = fso.replace('1/4', '¼');
      fso = fso.replace('1/2', '½');
      fso = fso.replace('3/4', '¾');
      return fso;
    });

    return(
      <div className="threed-configurator-menu-dimensions-tab">
        <FingerSize>
          <Dropdown
            title="Finger size"
            titleFontWeight={700}
            width={150}
            opacity={1}
            defaultOption={fingerSize}
            options={fingerSizeOptions}
            onChange={onFingerSizeChange}
            highlight={checkoutIssues.includes('fingerSize')}
          />
          <Dropdown
            title="Size format"
            titleFontWeight={700}
            width={150}
            opacity={0.5}
            defaultOption={fingerSizeFormat}
            options={fingerSizeFormatOptions}
            onChange={onFingerSizeFormatChange}
          />
        </FingerSize>
      
      <DimensionsSliders>
        <SliderContainer className="threed-configurator-slider-container">
    
          <SliderTitle>
            Width
          </SliderTitle>
    
          <Slider
            disabled={false}
            defaultValue={ringWidth}
            options={ringWidthOptions}
            onChange={onRingWidthChange}
            tooltipVisible={!scrolling}
          />
    
        </SliderContainer>
    
        <SliderContainer className="threed-configurator-slider-container">
    
          <SliderTitle>
            Thickness
          </SliderTitle>

          <Slider
            disabled={autoRatio}
            defaultValue={ringThickness}
            options={ringThicknessOptions}
            onChange={onRingThicknessChange}
            tooltipVisible={!scrolling}
          />
    
        </SliderContainer>
      </DimensionsSliders>
    
        <SwitchContainer>
          <Notification>
            <InfoIcon>
              <SvgIcon
                type="info"
                style={{ pointerEvents: 'none' }}
              />
            </InfoIcon>
            <Info>
              Select optimal width and thickness ratio automatically
            </Info>
          </Notification>
          <Switch
            defaultChecked={autoRatio}
            onChange={onAutoRatioChange}
          />
        </SwitchContainer>
      
      </div>
    );
  };// /render()
};// /class